var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-md-4" }, [
      _c("div", { staticClass: "form-group" }, [
        _c("label", [_vm._v("Название на платформе")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.taskData.drugDetails.title,
              expression: "taskData.drugDetails.title",
            },
          ],
          staticClass: "form-control",
          attrs: { type: "text" },
          domProps: { value: _vm.taskData.drugDetails.title },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.taskData.drugDetails, "title", $event.target.value)
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", [_vm._v("Название на английском")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.taskData.drugDetails.en_title,
              expression: "taskData.drugDetails.en_title",
            },
          ],
          staticClass: "form-control",
          attrs: { type: "text" },
          domProps: { value: _vm.taskData.drugDetails.en_title },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(
                _vm.taskData.drugDetails,
                "en_title",
                $event.target.value
              )
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", [_vm._v("Приоритет")]),
        _vm._v(" "),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.taskData.drugDetails.priority,
                expression: "taskData.drugDetails.priority",
              },
            ],
            staticClass: "form-control",
            on: {
              change: function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.$set(
                  _vm.taskData.drugDetails,
                  "priority",
                  $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                )
              },
            },
          },
          _vm._l(5, function (i) {
            return _c("option", { domProps: { value: i } }, [_vm._v(_vm._s(i))])
          }),
          0
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-4" }, [
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("label", [_vm._v("ЕГК")]),
          _vm._v(" "),
          _c("EgkSelect", {
            attrs: {
              hideDetails: true,
              updateDetail: (c) => _vm.addEgkCode(c),
            },
          }),
          _vm._v(" "),
          _vm._l(_vm.selectedEgkCodes, function (c, i) {
            return _c(
              "div",
              {
                staticClass: "flex mt-1 border pl-2 align-items-center bg-gray",
              },
              [
                _c("span", { staticClass: "flex-grow-1 pr-1" }, [
                  _vm._v(_vm._s(c.title)),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-sm btn-default",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.removeEgkCode(i)
                      },
                    },
                  },
                  [_c("i", { staticClass: "icon-fa icon-fa-remove" })]
                ),
              ]
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", [_vm._v("Главный ключевик")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.taskData.drugDetails.main_keywords,
              expression: "taskData.drugDetails.main_keywords",
            },
          ],
          staticClass: "form-control",
          attrs: { type: "text" },
          domProps: { value: _vm.taskData.drugDetails.main_keywords },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(
                _vm.taskData.drugDetails,
                "main_keywords",
                $event.target.value
              )
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", [_vm._v("Страна закупки")]),
        _vm._v(" "),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.taskData.drugDetails.income_country_id,
                expression: "taskData.drugDetails.income_country_id",
              },
            ],
            staticClass: "form-control",
            on: {
              change: function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.$set(
                  _vm.taskData.drugDetails,
                  "income_country_id",
                  $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                )
              },
            },
          },
          _vm._l(_vm.$AllCountries, function (c) {
            return _c("option", { domProps: { value: c.id } }, [
              _vm._v(_vm._s(c.name)),
            ])
          }),
          0
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-4 p-0 pl-1 pr-1" },
      [
        _c("label", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.useRecipe,
                expression: "useRecipe",
              },
            ],
            attrs: { type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.useRecipe)
                ? _vm._i(_vm.useRecipe, null) > -1
                : _vm.useRecipe,
            },
            on: {
              change: function ($event) {
                var $$a = _vm.useRecipe,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.useRecipe = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.useRecipe = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.useRecipe = $$c
                }
              },
            },
          }),
          _vm._v(" Рецетурность\n    "),
        ]),
        _vm._v(" "),
        _vm.useRecipe
          ? [
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Название на латыне")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.currentRecipe.lt_title,
                      expression: "currentRecipe.lt_title",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.currentRecipe.lt_title },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.currentRecipe,
                        "lt_title",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex" }, [
                _c("div", { staticClass: "form-group flex-grow-1" }, [
                  _c("label", [_vm._v("Применение")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.currentRecipe.signa,
                        expression: "currentRecipe.signa",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: _vm.currentRecipe.signa },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.currentRecipe,
                          "signa",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("К-во уп. в рец.")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.currentRecipe.pack,
                        expression: "currentRecipe.pack",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "number" },
                    domProps: { value: _vm.currentRecipe.pack },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.currentRecipe, "pack", $event.target.value)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Рец. дней")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.currentRecipe.days,
                        expression: "currentRecipe.days",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "number" },
                    domProps: { value: _vm.currentRecipe.days },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.currentRecipe, "days", $event.target.value)
                      },
                    },
                  }),
                ]),
              ]),
            ]
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("DiffPrices", {
              attrs: {
                prices: _vm.drugPrices,
                updateRecords: (p) => (_vm.drugPrices = p),
              },
            }),
          ],
          1
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }